import { useState, useEffect } from 'react'
import { MIST_CLOUD_URL } from 'app/consts'
import { makePublicUrl } from 'app/utils/publicUrl'
import DashboardGraph from '../Graph'
import StatusCard from '../StatusCard'
import AnalyticsLineItem from '../Analytics'
import {
  DateCardFrame,
  ClassifierFrame,
  DataCardLastColumn,
  DataCardLastColumnHeader,
  DataCardLastColumnBody,
  NavigateToMistButton,
  NavigateToMistForwardIcon,
} from './styles'
import { fetchSiteMetric } from 'features/networkAi/api'

import {
  analyticsHandler,
  servicePercentage,
  getFormattedClassifierName,
  classifierPercentage,
} from '../../../utils/analytics'

import { DEFAULT_SLE_VALUES } from './consts'

interface DataCardProps {
  siteId: string
  metric: string
  duration: number
  title: string
  orgId: string
}

function DataCard({ siteId, metric, duration, title, orgId }: DataCardProps) {
  const [interval, setInterval] = useState(600)
  const [isLoaded, setIsLoaded] = useState(false)

  const [start, setStart] = useState(0)
  const [end, setEnd] = useState(0)

  const [data, setData] = useState(DEFAULT_SLE_VALUES)

  /* eslint-disable */

  useEffect(() => {
    try {
      setIsLoaded(false)
      metricData(siteId, metric, duration)
      setInterval(600)
    } catch (e) {
      console.log('ERROR COMPONENTDIDMOUNT: ' + e)
      console.log(isLoaded)
    }
  }, [siteId, metric, duration, setIsLoaded])

  const metricData = async (
    siteId: string,
    metric: string,
    duration: number
  ) => {
    let end = Math.round(Date.now() / 1000)
    let start = end - duration

    setStart(start)
    setEnd(end)

    let dataFetch = await fetchSiteMetric(siteId, metric, start, end)
    try {
      setData(dataFetch.data)
      setIsLoaded(true)
    } catch (err) {
      console.log(err)
    }
  }

  const buildXArray = () => {
    let start = data.start
    let end = data.end
    let xArr = []
    for (let i = start; i <= end; i += interval) {
      xArr.push(i)
    }
    return xArr
  }

  const getXArray = buildXArray()
  const getDegraded = data.sle.samples.degraded
  const getTotal = data.sle.samples.total
  let percentage = servicePercentage(getDegraded, getTotal)
  const p2pArray = analyticsHandler(data.sle.name, data)

  const getTotalDegredation = () => {
    let total = 0
    for (let i = 0; i < data.classifiers.length; i++) {
      let d = data.classifiers[i].samples.degraded //array of numbers
      d.forEach((element) => {
        total += element
      })
    }
    return total
  }

  const getClassifiers = () => {
    let classifiersPercentage = []
    // populate the classifiers with actual percentages first.
    //They are unpredictable so have to traverse all classifiers twice to fill classifiers component
    let dataClassifiersCopy = data.classifiers
    for (let i = 0; i < dataClassifiersCopy.length; i++) {
      let classifier = data.classifiers[i]
      let service = {
        serviceName: '',
        servicePercentage: 0,
      }

      service['serviceName'] = getFormattedClassifierName(classifier.name)
      service['servicePercentage'] = classifierPercentage(
        classifier.samples.degraded,
        getTotalDegredation()
      )
      classifiersPercentage.push(service)
    }
    let displayClassifiers = []
    for (let i = 0; i < classifiersPercentage.length; i++) {
      if (classifiersPercentage[i].servicePercentage > 0) {
        displayClassifiers.push(classifiersPercentage[i])
      }
    }
    for (let i = 0; i < classifiersPercentage.length; i++) {
      if (displayClassifiers.includes(classifiersPercentage[i])) {
        continue
      } else if (displayClassifiers.length >= 5) {
        break
      } else {
        displayClassifiers.push(classifiersPercentage[i])
      }
    }
    return displayClassifiers
  }

  function MistUrl() {
    const url = `${MIST_CLOUD_URL}/admin/?org_id=${orgId}#!dashboard/serviceLevels/page2/stats/-/-/site/${siteId}/${metric}/-/-/today/${start}/${end}/${siteId}`
    return url
  }

  return (
    <DateCardFrame>
      <StatusCard title={title} data={percentage}></StatusCard>

      <DashboardGraph xArray={getXArray} yArray={p2pArray}>
        {' '}
      </DashboardGraph>

      <DataCardLastColumn>
        <DataCardLastColumnHeader>
          <NavigateToMistButton as="a" href={MistUrl()} target="_blank">
            <NavigateToMistForwardIcon
              src={makePublicUrl(`images/networkIcons/arrow-forward.svg`)}
            />
          </NavigateToMistButton>
        </DataCardLastColumnHeader>
        <DataCardLastColumnBody>
          <ClassifierFrame>
            {getClassifiers().map((item) => (
              <AnalyticsLineItem
                key={item.serviceName}
                serviceName={item.serviceName}
                servicePercentage={
                  item.servicePercentage === 0 ? '--' : item.servicePercentage
                }
              ></AnalyticsLineItem>
            ))}
          </ClassifierFrame>
        </DataCardLastColumnBody>
      </DataCardLastColumn>
    </DateCardFrame>
  )
}

export default DataCard
